<template>
  <div :class="$b()">
    <template v-if="methods.length">
      <PaymentIcon
        v-for="method in methods"
        :key="method"
        :method="method"
        :greyscale="greyscale"
        :size="size"
      />
    </template>
    <template v-else>
      <div
        v-for="n in 7"
        :key="`shimmer-${n}`"
        :class="[$b('method-shimmer'), 'vision-shimmer']"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'PaymentIcons',

  props: {
    methods: {
      type: Array,
      default: () => [],
    },
    greyscale: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['x-small', 'small', 'medium'].includes(value),
    },
  },
}
</script>

<style lang="postcss">
.PaymentIcons {
  @apply flex flex-wrap px-[var(--cart-inline-padding)] justify-center gap-2;
}

.PaymentIcons__method-shimmer {
  @apply w-[29px] h-[24px];
}
</style>
